<template>
	<div class="drawer">
		<el-drawer
		v-if="detail._id"
		size="65%"
		title="消费详情"
		:visible.sync="drawerStatus"
		@close='handleClose'
		>
			<div style="height: 100%;">
				<div style="padding-bottom:40px;">
					<el-row style="padding:10px 20px 0;float: none;font-size: 16px;">
						<el-col :span="8">
							<span class="label">顾客：</span>
							<span class="value">{{detail.user_info.nick_name}}</span>
						</el-col>
						<el-col :span="8">
							<span class="label">手机号：</span>
							<span class="value">{{detail.user_info.user_mobile}}</span>
						</el-col>
					</el-row>
					<el-row style="padding:10px 20px 0;float: none;font-size: 16px;">
						<el-col :span="8">
							<span class="label">订单类型：</span>
							<span class="value">{{detail.order_type}}</span>
						</el-col>
						<el-col :span="8">
							<span class="label">消费门店：</span>
							<span class="value">{{$public.getShopNameById(detail.company_info.shop_id)}}</span>
						</el-col>
						<el-col :span="8">
							<span class="label">优惠券：</span>
							<span class="value">
								<span v-if="detail.coupon_list&&detail.coupon_list.length>0">
									<span style="padding-right: 30px;" v-for="(item,index) in detail.coupon_list" :key="index">
										{{item.coupon_name}} ({{item._no}})
									</span>
								</span>
							</span>
						</el-col>
					</el-row>
					<el-row style="padding:10px 20px 0;float: none;font-size: 16px;">
						<el-col :span="8">
							<span class="label">总金额：</span>
							<span class="value">{{detail.total_price}}</span>
						</el-col>
						<el-col :span="8">
							<span class="label">支付方式：</span>
							<span class="value">
								<span v-if="detail.pay_info">
									<span style="padding-right: 30px;" v-for="(item,index) in detail.pay_info.pay_list" :key="index">
										<span style="padding-right: 2px;">
											{{$public.formatPayTypeState(item.pay_type)}}
										</span>
										{{item.money}}
									</span>
								</span>
							</span>
						</el-col>
						<el-col :span="8">
							<span class="label">结算备注：</span>
							<span class="value">
								<span v-if="detail.pay_info">
									{{detail.pay_info.pay_remark}}
								</span>
							</span>
						</el-col>
					</el-row>
					<el-row style="padding:10px 20px 0;float: none;font-size: 16px;">
						<el-col :span="8">
							<span class="label">添加人：</span>
							<span class="value">{{detail.create_manager_name}}</span>
						</el-col>
						<el-col :span="8">
							<span class="label">消费时间：</span>
							<span class="value">{{$public.FTime(detail.create_time)}}</span>
						</el-col>
						<el-col :span="8">
							<span class="label">订单备注：</span>
							<span class="value">{{detail.remark}}</span>
						</el-col>
					</el-row>
				</div>
				<div style="margin:0 20px;">
					<el-table :data="tableData" style="width: 100%;" height="600px" default-expand-all row-key="tableKey" :tree-props="{children: 'goodsList', hasChildren: 'hasChildren'}">
						<el-table-column type="expand">
							<template slot-scope="props">
								<div >
									<div v-if="!$public.isNull(props.row.goodsList)">
										<div v-for="item in props.row.goodsList" :key="item.tableKey">
											<el-tag style="margin: 5px;" v-if="item.customCode">
												<span v-if="props.row.goodsType===8">{{item.goodsName}} {{item.skuValue}}</span>
												{{item.customCode}}
											</el-tag>
										</div>
									</div>
									<div v-else>无条码</div>
								</div>
							</template>
						</el-table-column>
						<el-table-column label="商品名称" width="320">
							<template slot-scope="scope">
								{{scope.row.goodsName}}
							</template>
						</el-table-column>
						<el-table-column label="规格" >
							<template slot-scope="scope">
								{{
									scope.row.skuValue
								}}
							</template>
						</el-table-column>
						<el-table-column label="价格" width="120">
							<template slot-scope="props">
								{{props.row.price}}
							</template>
						</el-table-column>
						<el-table-column label="数量" width="100">
							<template slot-scope="props">
								<div v-if="props.row.goodsList">{{props.row.num}}</div>
							</template>
						</el-table-column>
						<el-table-column label="用量" width="120">
							<template slot-scope="props">
								<div v-if="props.row.goodsList">
									{{props.row.goodsDosage}}
									<span>{{props.row.outUnit}}</span>
								</div>
							</template>
						</el-table-column>
						<el-table-column label="单位" width="160">
							<template slot-scope="props">
								<div v-if="props.row.goodsList">{{props.row.unit}}</div>
							</template>
						</el-table-column>
					</el-table>
				</div>
				<!-- <el-row style="padding:50px 20px 0;float: none;font-size: 16px;">
					<el-col :span="4" :offset="16">
						<span class="label">共计：</span>
						<span class="value">{{total.count}}件</span>
					</el-col>
					<el-col :span="4">
						<span class="label">总计：</span>
						<span class="value">￥{{total.money}}</span>
					</el-col>
				</el-row> -->
			</div>
		</el-drawer>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				drawerStatus:false,
				detail:{},
				tableData:[],
			}
		},
		computed:{
			userInfo(){
				if(this.$store.state.mendian.userInfo._id){
					return this.$store.state.mendian.userInfo;
				}else{
					return {
						basic_info:{},
						card_info:{},
						company_info:{},
						operation_info:{},
						pets_info:[],
						club_card:{}
					}
				}
			},
			curPetId(){
				return this.$store.state.mendian.curPetId;
			},
		},
		props:{
			curItem:{
				default:()=>{
					return {}
				}
			}
		},
		mounted(){
			this.$nextTick(()=>{
				this.drawerStatus = true;
				this.getMsg(this.curItem._id)
			})
		},
		methods: {
			handleClose(){
				this.$emit('submit',{type:"close"})
			},
			// 获取信息
			getMsg(id){
				let loading = this.$loading()
				let params = {
					orderid: id
				}
				this.$http.get('/api/Order/GetOrder', params).then(res => {
					loading.close()
					if (res.code == 0) {
						this.detail = res.data;
						this.tableData = []
						for(let i=0;i<this.detail.order_item_list.length;i++){
							let one = {
								activityId: this.detail.order_item_list[i].activity_info&&this.detail.order_item_list[i].activity_info.activity_id, // 活动id
								activityName: this.detail.order_item_list[i].activity_info&&this.detail.order_item_list[i].activity_info.activity_name, // 活动名称
								goodsDosage: "", // 用量
								goodsId: this.detail.order_item_list[i].goods_id, // 商品id
								goodsName: this.detail.order_item_list[i].goods_name, // 商品名称
								goodsList: [], // children
								goodsType:  this.detail.order_item_list[i].goods_type, // 1:商品；2:服务；3:套餐
								goodsUsage: "", // 用法
								isPay: this.detail.state, // 是否支付
								num:this.detail.order_item_list[i].num, // 数量
								originalPrice: this.detail.order_item_list[i].original_price, // 原价
								price: this.detail.order_item_list[i].price, // 现价
								remark: this.detail.order_item_list[i].remarks, // 备注
								model: this.detail.order_item_list[i].sku_value, // 规格
								skuValue: this.detail.order_item_list[i].sku_value, // 规格
								skus: this.detail.order_item_list[i].skus_id, // 规格
								totalMoney: (this.detail.order_item_list[i].num*this.detail.order_item_list[i].price).toFixed(2), // 总价
								unit: this.detail.order_item_list[i].unit, // 单位
								staff: '',
								validityStopDate:this.detail.order_item_list[i].validity_stop_date
							}
							if(this.detail.order_item_list[i].sales_list){
								for(let b=0;b<this.detail.order_item_list[i].sales_list.length;b++){
									one.staff+=this.detail.order_item_list[i].sales_list[b].sales_name+' '
								}
							}
							if(this.detail.order_item_list[i].order_item_goods_list){
								for(let a=0;a<this.detail.order_item_list[i].order_item_goods_list.length;a++){
									let two = {
										tableKey:'tableKey_goods_two'+Math.random(),
										customCode: this.detail.order_item_list[i].order_item_goods_list[a].custom_code,
										activityId: "", // 活动id
										activityName: "", // 活动名称
										goodsDosage: "", // 用量
										goodsId: this.detail.order_item_list[i].order_item_goods_list[a].goods_id, // 商品id
										goodsName: this.detail.order_item_list[i].order_item_goods_list[a].goods_name, // 商品名称
										goodsType: this.detail.order_item_list[i].goods_type, // 1:商品；2:服务；3:套餐
										goodsUsage: "", // 用法
										isPay: this.detail.state, // 是否支付
										num: 1, // 数量
										originalPrice: this.detail.order_item_list[i].original_price, // 原价
										price: this.detail.order_item_list[i].price, // 现价
										remark: this.detail.order_item_list[i].remarks, // 备注
										model: this.detail.order_item_list[i].sku_value, // 规格
										skuValue: this.detail.order_item_list[i].sku_value, // 规格
										skus: this.detail.order_item_list[i].skus_id, // 规格
										totalMoney: (this.detail.order_item_list[i].num*this.detail.order_item_list[i].price).toFixed(2), // 总价
										unit: this.detail.order_item_list[i].unit, // 单位
										validityStopDate:this.detail.order_item_list[i].order_item_goods_list[a].validity_stop_date,
										returnState:false,
									}
									one.goodsList.push(two);
								}
							}
							this.tableData.push(one);
						}
					}
				})
			}
		}
	}
</script>

<style scoped lang="scss">
	.drawer{
		width:0;
		padding:0 0 0 0;
		::v-deep.el-drawer{
			.label{
				display: inline-block;width:100px;text-align: right;flex-shrink: 0;line-height: 24px;
			}
			.value{
				line-height: 24px;
			}
		}
		
	}
	
</style>
